import { FitScore } from "./FitScore";

export default FitScore;
